<template>
  <div class="publicMain">
    <div class="text-event" :style="mainStyle">
      <vue-draggable-resizable
        :w="200"
        :h="200"
        :parent="true"
        :debug="false"
        :min-width="200"
        :min-height="200"
        :isConflictCheck="true"
        :snap="true"
        :grid="[10, 10]"
        :snapTolerance="5"
        @refLineParams="getRefLineParams"
        class="test1">
      </vue-draggable-resizable>
        <!-- :dragging="onDrag"
        :resizing="onResize" -->
      <vue-draggable-resizable
        :w="200"
        :h="200"
        :parent="true"
        :x="210"
        :debug="false"
        :min-width="200"
        :min-height="200"
        :isConflictCheck="true"
        :snap="true"
        :grid="[10, 10]"
        :snapTolerance="5"
        @refLineParams="getRefLineParams"
        class="test2">
      </vue-draggable-resizable>
      <vue-draggable-resizable
        :w="200"
        :h="200"
        :parent="true"
        :x="420"
        :debug="false"
        :min-width="200"
        :min-height="200"
        :isConflictCheck="true"
        :snap="true"
        :grid="[10, 10]"
        :snapTolerance="5"
        @refLineParams="getRefLineParams"
        class="test3">
      </vue-draggable-resizable>
      <!--辅助线-->
      <span class="ref-line v-line"
        v-for="item in vLine"
        :key="item.id"
        v-show="item.display"
        :style="{ left: item.position, top: item.origin, height: item.lineLength}"
      />
      <span class="ref-line h-line"
        v-for="item in hLine"
        :key="item.id"
        v-show="item.display"
        :style="{ top: item.position, left: item.origin, width: item.lineLength}"
      />
      <!--辅助线END-->
    </div>
  </div>
</template>

<script>
export default {
  name: "sjmh",
  computed: {
    mainStyle() {
      return {
        'height': this.screenHeight - 195 + 'px',
        // 'overflow-y': 'auto',
      }
    },
  },
  data() {
    return {
      vLine: [],
      hLine: [],
      screenHeight: '0',
      screenWidth: '0',
    };
  },
  watch: {},
  methods: {
    // 辅助线回调事件
    getRefLineParams (params) {
      const { vLine, hLine } = params
      let id = 0
      this.vLine = vLine.map(item => {
        item['id'] = ++id
        return item
      })
      this.hLine = hLine.map(item => {
        item['id'] = ++id
        return item
      })
    }
  },
  created() {},
  mounted() {
    // $(".text-event").css("height", this.screenHeight - 195 + 'px');
    // 监听浏览器的宽和高   用来计算公告显示宽度
    // this.screenWidth = document.body.clientWidth;
    // this.screenHeight = document.body.clientHeight;
    // window.onresize = () => {
    //   return (() => {
    //     this.screenWidth = document.body.clientWidth;
    //     this.screenHeight = document.body.clientHeight;
    //   })();
    // };
    
    // 监听浏览器的宽和高
    this.screenHeight = document.body.clientHeight
    this.screenWidth = document.body.clientWidth
    window.addEventListener('resize', () => this.screenHeight = window.innerHeight, false)
    window.addEventListener('resize', () => this.screenWidth = window.innerWidth, false)
  }
};
</script>

<style lang="scss" scoped>
  .test1 {
    background-color: rgb(239, 154, 154);
  }
  .test2{
    background-color: rgb(129, 212, 250);
  }
  .test3{
    background-color: rgb(174, 213, 129);
  }
  .text-event {
    float: left;
    height: 100%;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    position: relative;
    background: linear-gradient(-90deg, rgba(0, 0, 0, 0.1) 1px, transparent 1px) 0% 0% / 10px 10px, linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 1px) 0% 0% / 10px 10px;
  }
</style>